import { Box, Link } from "@mui/material";

import { useOrganization } from "../../providers";

export const HelpLink = (props: React.ComponentProps<typeof Link>) => {
  const { configuration } = useOrganization();
  const HelpIcon = configuration.branding.help.icon;

  return (
    <Link
      href={configuration.branding.help.url}
      rel="noopener noreferrer"
      sx={{
        alignItems: "center",
        display: "flex",
        gap: 0.5,
        maxWidth: "100%",
        minWidth: 0,

        "&:not(:hover)": {
          textDecoration: "none",
        },
      }}
      target="_blank"
      {...props}
    >
      <HelpIcon sx={{ flexShrink: 0 }} />
      <Box
        component="span"
        sx={{
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {configuration.branding.help.text}
      </Box>
    </Link>
  );
};
